import React, { useState } from 'react';
import DialogComponent from '../dialog/dialog.component';
import { IUserProfile } from '../../models';
import EditProfileGeneral from './edit-profile-general';
import EditProfiledContact from './edit-profile-contact';
import EditProfileOrther from './edit-profile-orther';
import ChangePasswordForm from './edit-change-password';
import { useNavigate } from 'react-router-dom';
import EditProfileOther from './edit-profile-other';

interface EditProfiledDialogProps {
  profile: IUserProfile;

  onUpdateSuccess: () => void;
}

const EditProfiledDialog = ({
  profile,
  onUpdateSuccess,
}: EditProfiledDialogProps) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState('overview');
  const navigate = useNavigate();

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const onUpdateSuccessfull = () => {
    onUpdateSuccess();
    setVisible(false);
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <>
      <div
        id="edit-profile"
        onClick={() => setVisible(true)}
        className="text-base font-medium  text-white cursor-pointer rounded-xl bg-[#0057FF] gap-[10px] py-2 flex items-center justify-center "
      >
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.5 22H3.5C3.09 22 2.75 21.66 2.75 21.25C2.75 20.84 3.09 20.5 3.5 20.5H21.5C21.91 20.5 22.25 20.84 22.25 21.25C22.25 21.66 21.91 22 21.5 22Z"
            fill="white"
          />
          <path
            d="M19.5206 3.48016C17.5806 1.54016 15.6806 1.49016 13.6906 3.48016L12.4806 4.69016C12.3806 4.79016 12.3406 4.95016 12.3806 5.09016C13.1406 7.74016 15.2606 9.86016 17.9106 10.6202C17.9506 10.6302 17.9906 10.6402 18.0306 10.6402C18.1406 10.6402 18.2406 10.6002 18.3206 10.5202L19.5206 9.31016C20.5106 8.33016 20.9906 7.38016 20.9906 6.42016C21.0006 5.43016 20.5206 4.47016 19.5206 3.48016Z"
            fill="white"
          />
          <path
            d="M16.1103 11.5298C15.8203 11.3898 15.5403 11.2498 15.2703 11.0898C15.0503 10.9598 14.8403 10.8198 14.6303 10.6698C14.4603 10.5598 14.2603 10.3998 14.0703 10.2398C14.0503 10.2298 13.9803 10.1698 13.9003 10.0898C13.5703 9.8098 13.2003 9.4498 12.8703 9.0498C12.8403 9.0298 12.7903 8.9598 12.7203 8.8698C12.6203 8.7498 12.4503 8.5498 12.3003 8.3198C12.1803 8.1698 12.0403 7.9498 11.9103 7.7298C11.7503 7.4598 11.6103 7.1898 11.4703 6.9098C11.4491 6.86441 11.4286 6.81924 11.4088 6.77434C11.2612 6.44102 10.8265 6.34358 10.5688 6.60133L4.84032 12.3298C4.71032 12.4598 4.59032 12.7098 4.56032 12.8798L4.02032 16.7098C3.92032 17.3898 4.11032 18.0298 4.53032 18.4598C4.89032 18.8098 5.39032 18.9998 5.93032 18.9998C6.05032 18.9998 6.17032 18.9898 6.29032 18.9698L10.1303 18.4298C10.3103 18.3998 10.5603 18.2798 10.6803 18.1498L16.4016 12.4285C16.6612 12.1689 16.5633 11.7235 16.2257 11.5794C16.1877 11.5632 16.1492 11.5467 16.1103 11.5298Z"
            fill="white"
          />
        </svg>

        <span>Chỉnh sửa chi tiết</span>
      </div>
      <DialogComponent
        onClose={() => setVisible(false)}
        visible={visible}
        title="Cập nhật tài khoản"
        placement="CENTER"
        size="full"
      >
        <nav className="w-[976px] flex gap-1 px-6 text-[15px] font-medium max-md:w-full max-md:overflow-x-auto border-b border-[#EEF0F4] dark:border-slate-700">
          <div
            className={`inline-block cursor-pointer whitespace-nowrap py-3 px-4 -mb-px border-b-2 transition-colors ${
              activeTab === 'overview'
                ? 'border-[#0057FF] text-[#0057FF] font-semibold'
                : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-white'
            }`}
            onClick={() => handleTabClick('overview')}
          >
            Chỉnh sửa chi tiết
          </div>
          <div
            className={`inline-block cursor-pointer whitespace-nowrap py-3 px-4 -mb-px border-b-2 transition-colors ${
              activeTab === 'other'
                ? 'border-[#0057FF] text-[#0057FF] font-semibold'
                : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-white'
            }`}
            onClick={() => handleTabClick('other')}
          >
            Khác
          </div>
          <div
            className={`inline-block cursor-pointer whitespace-nowrap py-3 px-4 -mb-px border-b-2 transition-colors ${
              activeTab === 'change-password'
                ? 'border-[#0057FF] text-[#0057FF] font-semibold'
                : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-white'
            }`}
            onClick={() => handleTabClick('change-password')}
          >
            Thay đổi mật khẩu
          </div>
        </nav>
        <div className="overflow-hidden text-sm w-full max-w-[976px]">
          {activeTab === 'overview' && (
            <EditProfileGeneral
              onClose={onClose}
              profile={profile}
              onUpdateSuccess={onUpdateSuccessfull}
            />
          )}
          {activeTab === 'other' && (
            <EditProfileOther
              onClose={onClose}
              profile={profile}
              onUpdateSuccess={onUpdateSuccessfull}
            />
          )}
          {activeTab === 'change-password' && (
            <ChangePasswordForm onClose={onClose} />
          )}
        </div>
      </DialogComponent>
    </>
  );
};

export default EditProfiledDialog;
